import { render, staticRenderFns } from "./GrcButton.vue?vue&type=template&id=77d283fe&scoped=true&"
import script from "./GrcButton.vue?vue&type=script&lang=js&"
export * from "./GrcButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d283fe",
  null
  
)

export default component.exports